import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SICOM_PATHS } from 'src/sicom-paths';
import { PrestadorRecursoMaterial, PrestadorRecursoMaterialRequest } from './prestador-recursos-materiais.model';
@Injectable({ providedIn: 'root' })
export class PrestadorRecursosMateriaisService {
    private readonly http = inject(HttpClient);
    private readonly url = SICOM_PATHS.registro.prestador.recursosMateriais;
    listar(id: number, uf: string) {
        return this.http.get<PrestadorRecursoMaterial[]>(this.url, { params: { id, uf } });
    }
    tipos() {
        return this.http.get<PrestadorRecursoMaterial[]>(`${this.url}/tipos`);
    }
    criar(request: PrestadorRecursoMaterialRequest) {
        return this.http.post<void>(this.url, request);
    }
    atualizar(request: PrestadorRecursoMaterialRequest) {
        return this.http.put<void>(this.url, request);
    }
    remover(request: PrestadorRecursoMaterialRequest) {
        return this.http.delete<void>(this.url, { body: request });
    }
}
